import { Partial } from '@40seas/entities/common';
import { CreditLineRequest } from './credit-line-request.entity';

export class UpdateCreditLineRequestDto extends Partial(CreditLineRequest) {}
